const _nav = [
  {
    name: "Accueil",
    to: "hero",
  },
  {
    name: "à propos de nous",
    to: "about",
  },
  {
    name: "Services et Produits",
    to: "solutions",
  },
  {
    name: "Produits",
    to: "Produits",
  },
  {
    name: "Contactez Nous",
    to: "contact",
  },
];

export default _nav;
